module.exports = __webpack_public_path__ + "static/media/viking-login-small-bg.37b06ce4.jpg";